export default "__VITE_ASSET__D$7vU9KZ__"